import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { CheckCircleIcon, ErrorIcon, WarningIcon, InfoIcon } from 'icons/materialIcons';

const severityIcons = {
  success: <CheckCircleIcon sx={{ fontSize: 48, color: '#4CAF50' }} />,
  error: <ErrorIcon sx={{ fontSize: 48, color: '#F44336' }} />,
  warning: <WarningIcon sx={{ fontSize: 48, color: '#FF9800' }} />,
  info: <InfoIcon sx={{ fontSize: 48, color: '#2196F3' }} />
};

const MobileNotification = ({
  open,
  onClose,
  message,
  severity = 'success',
  buttonText = 'OK'
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          m: 2,
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            py: 2
          }}
        >
          {severityIcons[severity]}
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              color: '#333',
              fontSize: '1rem',
              fontWeight: 500,
              lineHeight: 1.5
            }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button
          fullWidth
          onClick={onClose}
          sx={{
            backgroundColor: '#2196F3',
            color: 'white',
            py: 1.5,
            textTransform: 'none',
            borderRadius: 1.5,
            fontSize: '0.9rem',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#1976D2'
            }
          }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MobileNotification;